import { createCardRequest } from "../../services/cardService";

export function DebugToolCreatedCardSnippet() {
    
    function onShow() {
        const req = createCardRequest('<payment token>', true);
        return JSON.stringify(req, null, 1);
    }
    return (
        <div className="snippet-container">
            <pre>
                { onShow() }
            </pre>
        </div>
    )
}